
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB7UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/0WC/4+0/5u8/2mb/4Os//L3/////83e/1GL/2qb /83d/6jF/+bv/12T/5y9/7TO/9rm/+bu/3Wj/5y8/4Ks/wAAAC/thBsAAAASdFJOUwBAj9/PnyAQ kI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH 5wwEAzkiVKWJywAAANNJREFUKM990tkSgjAMBdBYVlc0pUhABVHx///QQkFaJ/W+sJwJTNIA6KxE gE7CKAaTJEUm62S0ENlsBk3RkzVAjN5sIfKjgN3yIHNV2BjAcn8uiaiSli5YD0akWDyPRiWLyiCx eDF2ZRGrEQse5a2hq9OLhSjbokUW5b0Zvqq1o4d0sW3mLjt9yR2sjT2N0cvB3PSRY29PacI3TX1U 9gTnf/alwcaeLnxX6/JWSmLdLseyh4P/sCPY+lGvp7dU6O3L/q0mZGytSKadj6Of6qM4De8/0kI3 XU9WPKMAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMTItMDRUMDI6MzI6MTErMDA6MDBnkLLfAAAA JXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEyLTA0VDAyOjMyOjExKzAwOjAwFs0KYwAAACh0RVh0ZGF0 ZTp0aW1lc3RhbXAAMjAyMy0xMi0wNFQwMzo1NzozNCswMDowMILP2+QAAAAASUVORK5CYII="}})])
          )
        }
      }
    